module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', [_vm._v("The Biology"), _c('br'), _vm._v("\n  of Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("Grace, Hope, and Healing"), _c('br'), _vm._v("\n  for Those Who Feel Trapped")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("Matthew S. Stanford, Ph.D.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "Images/IVP_Books_Quarter.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55af9e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/title.vue
// module id = 63
// module chunks = 0